import { Switch, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Container from "@mui/material/Container";

import styles from "../../styles/layout/panel.module.scss";

// Import components
import Header from "./header";
import Footer from "./footer";
import NavBox from "./navBox";
import BottomNav from "./bottomNav";
import useHeight from "../../utility/hooks/useHeight";
import { Stack } from "@mui/material";

const PanelLayout = ({ children, allRoutes = [], defaultItems }) => {
  const location = useLocation();
  // مسیر فعلی رو می‌گیره (مثلاً: /walletLogin/123)
  const currentPath = location?.pathname;
  console.log("currentPath", currentPath);

  const showHeaderFooter = useSelector(
    (state) => state.layout.showHeaderFooter,
  );
  const { search } = useLocation();
  let query = new URLSearchParams(search);
  var showFromApp = query.get("from") === "app";
  const height = useHeight();

  const renderLayoutNav = () => {
    return (
      <Switch>
        {allRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            exact={route.exact}
            render={() => (
              <>
                {showHeaderFooter && <NavBox customItems={route.navBoxItems} />}
                {children}
                <Stack
                  sx={{
                    visibility: {
                      xs: currentPath === "/beh-park" ? "hidden" : "visible",
                    },
                  }}
                >
                  {showHeaderFooter && (
                    <BottomNav customItems={route.navBoxItems} />
                  )}
                </Stack>
              </>
            )}
          />
        ))}
      </Switch>
    );
  };
  let from = localStorage.getItem("from");
  if (from && from === "app") {
    showFromApp = true;
  } else if (query.get("from") === "app") {
    localStorage.setItem("from", "app");
  }

  return (
    <>
      {showHeaderFooter && <Header styles={styles.header} />}

      <Container
        maxWidth="xl"
        sx={{
          pt: 0,
          px: 1,
          pb: { xs: "70px", md: 2 },
          minHeight: "100vh",
          // height: "100vh",
        }}
        className={styles.container}
      >
        {defaultItems ?
          <>
            {showHeaderFooter && <NavBox />}
            {children}
            {showHeaderFooter && <BottomNav />}
          </>
        : renderLayoutNav()}
      </Container>

      {showHeaderFooter && <Footer styles={styles.footer} />}
    </>
  );
};

export default PanelLayout;
